import { useState, useEffect } from 'react';

export const useMaintenanceCheck = () => {
    const [nhsBsaMaintenance, setNhsBsaMaintenance] = useState(null);
    const [isMaintenanceActive, setIsMaintenanceActive] = useState(false);
    const [showAlert, setShowAlert] = useState(false);

    const checkNhsBsaMaintenanceWindow = () => {
        if (!nhsBsaMaintenance || !nhsBsaMaintenance.downtimeStart || !nhsBsaMaintenance.downtimeEnd) {
            return false; // No maintenance data or invalid data
        }

        const now = new Date();
        const downtimeStart = new Date(nhsBsaMaintenance.downtimeStart);
        const downtimeEnd = new Date(nhsBsaMaintenance.downtimeEnd);
        
        return now >= downtimeStart && now < downtimeEnd;
    };

    const updateNhsBsaMaintenance = (maintenanceData) => {
        setNhsBsaMaintenance(maintenanceData);
    };

    useEffect(() => {
        if (nhsBsaMaintenance) {
            let isActive = checkNhsBsaMaintenanceWindow();
            setIsMaintenanceActive(isActive);
            setShowAlert(isActive);
        }
        else {
            setIsMaintenanceActive(false);
            setShowAlert(false);
        }

    }, [nhsBsaMaintenance]);

    return {
        nhsBsaMaintenance,
        isMaintenanceActive,
        showAlert,
        setShowAlert,
        updateNhsBsaMaintenance,
    };
};

export default useMaintenanceCheck;
